import { Icon } from "armstrong-react";
import React from "react";
import { HubspotNewsletterSignupForm } from "../../../../web/components/hubspotForm/hubspotForm";

export const NewsletterSubCard = () => {
  return (
    <div className="content-card no-link newsletter-sub">
      <Icon className="content-type-icon" icon={Icon.Icomoon.newspaper} />
      <h3>Sign up to our newsletter!</h3>
      <p className="card-description">We'll send you tips, tricks, and inspiration for your travels, and keep you updated with insights from our local experts.</p>
      <HubspotNewsletterSignupForm />
    </div>
  );
};
